<template>
  <div>
    <Gamesheet :period=1  :game_id="this.$route.params.gameId"></Gamesheet>
  </div>
</template>


<script>
import Gamesheet from './season-stats/Gamesheet2021.vue'
export default {
  name: 'player',
  components: {
    Gamesheet
  },
  data () {
    return {
      period: 1
    }
  },
  computed: {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.team_logo{
  width: 100px;
  height:100px;
}
.tbl-name{
  width:10%;
}
.tbl-goal{
  background-color:rgba(202, 202, 202, 0.493); 
  color:black;
}
.tbl-shots{
  background-color:rgba(185, 190, 197, 0.493);
  color:black;
}
.large{
  font-size:1.5em;
}
.medium{
  font-size:1.2em;
}
.fo-left{
  background-color:rgba(173, 231, 220, 0.493);
  color:black;
}
.fo-center{
  background-color:rgba(158, 147, 157, 0.493);
  color:black;
}
.fo-right{
  background-color:rgba(68, 140, 148, 0.493);
  color:black;
}
.fo-total{
  background-color:rgba(230, 230, 169, 0.493);
  color:black;
}
.small {
  font-size: 1em;
  display: inline-block;
}
.table-responsive {
  display: block;
  width: 100%;
  min-height: 0.01%;
  overflow-x: auto;
}
.active p{
  font-size:84px;
}
.bold-el{
  font-size:26px;
  font-style: bold;
}
.select{
      font-size: 20px;
}
.is-success {
  font-size: 1.5em;
}
.is-danger {
  font-size: 1.5em;
}
.td p {
  font-size: 0.5em;

}
.table th {
    text-align: center;
}
.table td {
    text-align: center;
}
.player_icon {
  width: 162px;
  height: 162px;
  border-radius: 50%;
  vertical-align: middle;
}
.team_text {
  font-size: 1.5em;
  margin-left: 20px;
}
.player_info {
  font-size: 1.4em;
}
.score {
  font-size: 34px;
}

@media screen and (max-width: 600px){
     .is-canvas-responsive{
         display:none;
    }
}
 @media screen and (max-width: 800px){
     .is-responsive{
         width: 100%;
         border-collapse: collapse;
         border-spacing: 0;
         display: block;
         position: relative;
    }
     td:empty:before{
         content: '\00a0';
    }
     th, td{
         margin: 0;
         vertical-align: top;
    }
     th{
         text-align: left;
    }
     thead{
         border-right: solid 2px;
         display: block;
         float: left;
    }
     tr{
         display: block;
         padding: 0 10px 0 0;
    }
     th::before{
         content: "\00a0";
    }
     td, th{
         border-width: 0 0 1px;
    }
     tbody{
         display: block;
         width: auto;
         position: relative;
         overflow-x: auto;
         white-space: nowrap;
    }
     tr{
         display: inline-block;
         vertical-align: top;
    }
     th{
         display: block;
         text-align: right;
    }
     td{
         display: block;
         min-height: 1.25em;
         text-align: left;
    }
     th, td &:last-child{
         border-bottom-width: 0;
    }
     tr &:last-child td:not(:last-child){
         //border: $table-cell-border;
         // border-width: $table-cell-border-width;
    }
     &.is-bordered td, th{
         border-width: 1px;
    }
     tr td, th &:last-child{
         border-bottom-width: 1px;
    }
     &:last-child td, th{
         border-width: 1px;
    }
}
</style>



// WEBPACK FOOTER //
// match-stats-test.vue?7e2b9e2c